<template>
    <div class="container">
        <div class="form">
            <div class="form-item">
                <div class="form-item-title">基础信息</div>
                <div class="form-item-box" v-watermark>
                    <div class="item">
                        <div class="item-box">
                            <div class="label">姓名</div>
                            <div class="value">
                                <div class="text">{{ form.name }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="item-box">
                            <div class="label">年龄</div>
                            <div class="value">
                                <div class="text">{{ form.age }}岁</div>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="item-box">
                            <div class="label">性别</div>
                            <div class="value">{{ form.sex | sexFilter }}</div>
                        </div>
                    </div>
                    <template v-if="form.guardianName">
                        <div class="item">
                            <div class="item-box">
                                <div class="label">监护人姓名</div>
                                <div class="value">
                                    <div class="text">{{ form.guardianName }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="item" style="width: 100%">
                            <div class="item-box">
                                <div class="label">监护人电话</div>
                                <div class="value">
                                    <div class="text">{{ form.guardianMobile }}</div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <div class="item" v-else>
                        <div class="item-box">
                            <div class="label">手机号</div>
                            <div class="value">
                                <div class="text">{{ form.mobile }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="item-box">
                            <div class="label">关系</div>
                            <div class="value">
                                <div class="select" @click="relationship.show = true">
                                    <div class="name">{{ onRelationshipFilter(form.relation) }}</div>
                                    <div class="arrow">
                                        <van-icon name="arrow-down" :size="14" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="item-box">
                            <div class="label">城市</div>
                            <div class="value">
                                <div class="select" @click="region.show = true">
                                    <div class="name">{{ form.address || '请选择' }}</div>
                                    <div class="arrow">
                                        <van-icon name="arrow-down" :size="14" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="item full">
                        <div class="item-box">
                            <div class="label">身份证号</div>
                            <div class="value">
                                <div class="text">{{ form.idCard }}</div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="item full">
                        <div class="item-box">
                            <div class="label">备注</div>
                            <div class="value">
                                <van-field class="textarea" v-model="form.message" rows="2" autosize type="textarea" maxlength="50" placeholder="请输入备注" show-word-limit />
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>

            <div class="form-item health">
                <div class="form-item-title">健康档案</div>
                <div class="form-item-box" v-watermark>
                    <div class="item full">
                        <div class="item-box">
                            <div class="label">生育史</div>
                            <div class="value">
                                <div class="select" @click="maritalStatus.show = true">
                                    <div class="name">{{ form.maritalStatus || '请选择' }}</div>
                                    <div class="arrow">
                                        <van-icon name="arrow-down" :size="14" />
                                    </div>
                                </div>
                                <div class="select" @click="maternityStatus.show = true">
                                    <div class="name">{{ form.maternityStatus || '请选择' }}</div>
                                    <div class="arrow">
                                        <van-icon name="arrow-down" :size="14" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="item full">
                        <div class="item-box">
                            <div class="label">疾病史</div>
                            <div class="value">
                                <patient-checkbox v-model="form.diseaseHistory" :options="options.diseaseHistory" />
                            </div>
                        </div>
                    </div>
                    <div class="item full">
                        <div class="item-box">
                            <div class="label wrap">手术史或外伤史</div>
                            <div class="value">
                                <patient-checkbox v-model="form.operation" :options="options.operation" />
                            </div>
                        </div>
                    </div>
                    <div class="item full">
                        <div class="item-box">
                            <div class="label">家族病史</div>
                            <div class="value">
                                <patient-checkbox v-model="form.familyHistory" :options="options.familyHistory" />
                            </div>
                        </div>
                    </div>
                    <div class="item full">
                        <div class="item-box">
                            <div class="label">药物过敏</div>
                            <div class="value">
                                <patient-checkbox v-model="form.drugAllergy" :options="options.drugAllergy" />
                            </div>
                        </div>
                    </div>
                    <div class="item full">
                        <div class="item-box">
                            <div class="label wrap">食物/接触物过敏</div>
                            <div class="value">
                                <patient-checkbox v-model="form.foodAllergy" :options="options.foodAllergy" />
                            </div>
                        </div>
                    </div>
                    <div class="item full" v-if="form.sex == 0">
                        <div class="item-box">
                            <div class="label wrap">月经史</div>
                            <div class="value">
                                <van-field class="input" v-model="form.menstrualHistory" rows="3" autosize type="textarea" placeholder="" />
                            </div>
                        </div>
                    </div>
                    <div class="item full">
                        <div class="item-box">
                            <div class="label wrap">辅助检查史</div>
                            <div class="value">
                                <van-field class="input" v-model="form.auxiliaryExamination" rows="3" autosize type="textarea" placeholder="" />
                            </div>
                        </div>
                    </div>
                    <!-- <div class="item full">
                        <div class="item-box">
                            <div class="label">个人习惯</div>
                            <div class="value">
                                <patient-checkbox v-model="form.habit" :options="options.habit" />
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
        <div class="form-button">
            <div class="form-button-box">
                <van-button type="info" :loading="!submit" @click="onSubmit">确认修改</van-button>
                <van-button @click="$router.back()" :disabld="!submit">取消修改</van-button>
            </div>
        </div>

        <van-action-sheet v-model="relationship.show" :actions="relationship.list" close-on-click-action @select="onRelationshipChange" />

        <van-action-sheet v-model="region.show">
            <van-area :value="form.addressCode" :area-list="region.areaList" :columns-num="2" @confirm="onRegionConfirm" @cancel="onRegionCancel" />
        </van-action-sheet>

        <van-action-sheet v-model="maritalStatus.show" :actions="options.maritalStatus && options.maritalStatus.map((item) => ({ name: item })) || []" close-on-click-action @select="onMaritalStatusConfirm" />
        <van-action-sheet v-model="maternityStatus.show" :actions="options.maternityStatus && options.maternityStatus.map((item) => ({ name: item })) || []" close-on-click-action @select="onMaternityStatusConfirm" />
    </div>
</template>
<script>
import { Dialog } from 'vant';
import { areaList } from '@vant/area-data';
import patientCheckbox from '@/components/patient/checkbox.vue';
import { getMemberhealth, getMemberHealthTagList, setMemberHealthUpdate } from '@/api/index'

export default {
    components: {
        patientCheckbox
    },
    data() {
        return {
            form: {
                id: '',
                name: '',
                age: '',
                sex: 0,
                relation: 0,
                address: '',
                addressCode: '',
                maritalStatus: '',
                maternityStatus: '',
                idCard: '',
                diseaseHistory: '',
                operation: '',
                familyHistory: '',
                drugAllergy: '',
                foodAllergy: '',
                habit: '',
                userNo: '',
                realName: 0,
                province: '',
                mobile: '',
                menstrualHistory: '',
                auxiliaryExamination: ''
            },
            relationship: {
                show: false,
                list: [
                    {
                        name: '本人',
                        relation: 0
                    },
                    {
                        relation: 1,
                        name: '配偶'
                    },
                    {
                        relation: 2,
                        name: '父母'
                    },
                    {
                        relation: 3,
                        name: '子女'
                    },
                    {
                        relation: 4,
                        name: '其他'
                    }
                ]
            },
            region: {
                areaList: areaList,
                show: false
            },
            options: {
                // "maternityStatus": ["未生育", "备孕期", "怀孕中", "已生育"],
                // "diseaseHistory": ["暂无", "高血压", "糖尿病", "心脏病", "过敏性疾病", "白癜风", "癫痫", "哮喘", "其他"],
                // "habit": ["暂无", "低头", "久坐", "强忍大小便", "喝酒", "熬夜", "跷二郎腿", "吸烟", "饭后卧床", "不常锻炼", "不喜喝水", "其他"],
                // "foodAllergy": ["暂无", "芒果", "牛奶", "坚果类", "海鲜", "黄瓜", "花粉", "油漆", "动物皮毛", "化妆品", "其他"],
                // "familyHistory": ["暂无", "高血压", "糖尿病", "心脏病", "脑梗", "白癜风", "癫痫", "哮喘", "近视", "冠心病", "脑卒中", "血脂异常", "慢性阻塞性肺疾病", "癌症", "结核病", "肺炎", "严重精神障碍", "其他"],
                // "drugAllergy": ["暂无", "青霉素", "头孢类", "破伤风抗毒素", "普鲁卡因", "地卡因", "磺胺类", "维生素B1", "泛影葡胺", "阿司匹林", "其他"],
                // "operation": ["暂无", "颅脑手术", "颈部手术", "骨折", "腹部", "背部", "四肢", "软组织", "刀砍伤", "肌腱损伤", "其他"],
                // "maritalStatus": ["未婚", "已婚", "其他"]
            },
            maritalStatus: {
                show: false
            },
            maternityStatus: {
                show: false
            },
            submit: true
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            this.onDataGet();
        },
        onDataGet() {
            getMemberHealthTagList({
                userNo: this.$route.query.userNo,
                memberId: this.$route.query.memberId
            }).then(({ data }) => {
                this.options = data;
                return getMemberhealth({
                    userNo: this.$route.query.userNo,
                    memberId: this.$route.query.memberId
                });
            }).then(({ data }) => {
                data.address = data.province + data.city;
                this.form = Object.assign({}, this.form, data, {
                    age: this.$route.query.age,
                    userNo: this.$route.query.userNo
                })
            })
        },
        onRelationshipChange(row) { //关系选择
            this.form.relation = row.relation;
        },
        onRelationshipFilter(val) { //关系过滤，显示名称
            let list = this.relationship.list;
            for (let i = 0; i < list.length; i++) {
                if (list[i].relation == val) {
                    return list[i].name;
                }
            }
            return ''
        },
        onRegionConfirm(arr) { //区域选择
            this.form.address = arr.reduce((total, item) => {
                return total.name != item.name ? total.name + item.name : total.name
            });
            this.form.province = this.form.address;
            this.form.addressCode = arr[arr.length - 1].code;
            this.region.show = false;
        },
        onRegionCancel() { //区域关闭
            this.region.show = false;
        },
        onMaritalStatusConfirm(row) { //生育史-婚姻状况
            this.form.maritalStatus = row.name;
        },
        onMaternityStatusConfirm(row) { //生育史-生育状态
            this.form.maternityStatus = row.name;
        },
        onSubmit() {
            if (!this.submit) return false;
            let form = this.form;
            if (!form.address) {
                this.$toast('请选择城市');
                return false;
            } else if (!form.maritalStatus || !form.maternityStatus) {
                this.$toast('完善生育史');
                return false;
            } else if (!form.diseaseHistory) {
                this.$toast('请选择疾病史，如没有，请选择暂无');
                return false;
            } else if (!form.operation) {
                this.$toast('请选择手术史或外伤史，如没有，请选择暂无');
                return false;
            } else if (!form.familyHistory) {
                this.$toast('请选择家族史，如没有，请选择暂无');
                return false;
            } else if (!form.drugAllergy) {
                this.$toast('请选择药物过敏，如没有，请选择暂无');
                return false;
            } else if (!form.foodAllergy) {
                this.$toast('请选择食物/接触物过敏，如没有，请选择暂无');
                return false;
            }
            this.submit = false;
            this.$delete(form, 'idCard')
            setMemberHealthUpdate(form).then(({ data }) => {
                this.$toast(data);
                setTimeout(() => {
                    this.submit = true;
                    this.$router.back();
                }, 1000)
            }).catch(() => {
                this.submit = true;
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.container {
    padding-bottom: 30px;
    .form {
        &-item {
            background: #fff;
            margin-top: 20px;
            padding: 20px;
            &:first-child {
                margin-top: 0;
            }
            .form-item-title {
                font-size: 18px;
                font-weight: bold;
            }
            .form-item-box {
                display: flex;
                flex-wrap: wrap;
                margin-left: -10px;
                .item {
                    width: 50%;
                    &.full {
                        width: 100%;
                    }
                    &-box {
                        margin-left: 10px;
                        margin-top: 20px;
                        display: flex;
                        align-items: flex-start;
                        .label {
                            margin-right: 10px;
                            color: #9f9fab;
                            line-height: 32px;
                            flex: none;
                            &.wrap {
                                max-width: 4em;
                            }
                        }
                        .text {
                            line-height: 32px;
                            color: #636379;
                        }
                        .value {
                            flex: 1;
                            display: flex;
                            .select {
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                border: 1px solid #e6e6e6;
                                padding: 0 10px;
                                font-size: 14px;
                                height: 30px;
                                border-radius: 4px;
                                white-space: nowrap;
                                min-width: 3em;
                                margin-left: 10px;
                                &:first-child {
                                    margin-left: 0;
                                }
                                .name {
                                    margin-right: 5px;
                                    max-width: 100px;
                                    overflow: hidden;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                }
                            }
                            .textarea {
                                width: 100%;
                                background: #f6fbff;
                            }
                            .input {
                                border: 1px solid #eee;
                                border-radius: 4px;
                                padding: 10px;
                            }
                        }
                    }
                }
            }
            &.health {
                .form-item-box {
                    .item {
                        .item-box {
                            display: block;
                            .label {
                                max-width: 100%;
                                color: #333;
                                margin-bottom: 5px;
                                font-size: 16px;
                                font-weight: bolder;
                            }
                        }
                    }
                }
            }
        }
    }
    .form-button {
        height: 80px;
        padding-bottom: env(safe-area-inset-bottom);
        &-box {
            position: fixed;
            left: 0;
            right: 0;
            bottom: 0;
            height: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 10px;
            background: #fff;
            padding-bottom: env(safe-area-inset-bottom);
            .van-button {
                width: 100%;
                margin: 0 10px;
                border-radius: 6px;
            }
        }
    }
}
</style>